export const timetable = {
    myTimetable: "My Timetable",
    examTimetable: "Exam Timetable",
    addLectureConflict: "Cannot add lectures that conflict with existing timetable.",
    pasteLectureConflict:
        "There is a conflict with this lecture in the timetable. Would you like to replace it?",
    myTimeTableLectureAddWarning: "Cannot add lectures to My Timetable.",
    timetableKeyboardDeleteConfirm:
        "Are you sure you want to delete the current timetable?",
    copyImage: "Copy as Image",
    exportImage: "Export as Image",
    exportICal: "Export as Calendar",
    addToWishlist: "Add to Wishlist",
    addToTimetable: "Add to Timetable",
    removeFromWishlist: "Remove from Wishlist",
    removeFromTimetable: "Remove from Timetable",
    competitionRate: "Competition",
    noTimeInfo: "No Time Info",
    numSelected: " Lectures Selected",
    shortcuts: {
        modalTitle: "Keyboard Shortcuts",
        lectureSection: "Lecture Edit",
        timetableSection: "Timetable Control",
        etcSection: "Etc Navigations",
        lectureMultiple: "Lecture multiple select",
        lectureCopy: "Copy selected lectures",
        lectureCut: "Cut selected lectures",
        lecturePaste: "Paste selected lectures",
        lectureAll: "Select all lectures in timetable",
        lectureDelete: "Delete selected lectures",
        timetableUndo: "Undo latest action (managed per timetable)",
        timetableRedo: "Redo latest undo action (managed per timetable)",
        timetableAdd: "Add empty timetable",
        timetableDuplicate: "Duplicate current timetable",
        timetableDelete: "Delete current timetable (when there is no selected lectures)",
        timetableSelect: "Select timetable",
        etcSemester: "Semester change",
        etcLectureSearchMove: "Explore in lecture search result",
        etcLectureAddDelete: "Add or delete current exploring lecture",
        etcSelectCancel: "Cancel selected lectures",
        etcShortcutInfo: "Show this shortcut information",
    },
    addCustomBlock: "Add Custom Block",
    customBlock: {
        name: "Name",
        place: "Place",
        timetable: "Timetable",
        time: "Time",
        add: "Add to Timetable",
        save: "Save",
        overlap: "This time overlaps another custom block.",
        errorNameRequired: "Please enter a name for the block.",
        errorTimeInvalid: "End time must be later than start time.",
    },
}
